import { useState } from 'react';

/** sessionStorage에 값을 유지하는 useState. 새로고침으로 상태를 우회하지 못하게 할 때 사용한다 */
export function useSessionStorageState<T>(key: string, defaultValue: T) {
  const [value, setValue] = useState<T>(() => {
    try {
      const stored = sessionStorage.getItem(key);
      return stored !== null ? (JSON.parse(stored) as T) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  const update = (next: T | ((prev: T) => T)) => {
    setValue((prev) => {
      const resolved = typeof next === 'function' ? (next as (prev: T) => T)(prev) : next;
      try {
        sessionStorage.setItem(key, JSON.stringify(resolved));
      } catch {
        // sessionStorage를 사용할 수 없는 환경이면 메모리 상태만 갱신한다
      }
      return resolved;
    });
  };

  return [value, update] as const;
}
